import { setDeviceConfigPayload } from "../../../testActions";
import { store } from "../../../testStore";
import { S } from '../../../routes/routes';

export function selectCategory(category) {
  for (let i = 0; i < category.length; i++) {
    if (category[i] === 'lorawan') {
      return 'lora'
    } else if (category[i] === 'zlan') {
      return 'zlan'
    } else if (category[i] === 'usr-iot') {
      return 'ui'
    } else if (category[i] === 'bivocom') {
      return 'bivocom'
    } else if (category[i] === 'friendcom') {
      return 'friendcom'
    } else if (category[i] === 'iotera') {
      return 'iotera'
    } else if (category[i] === 'iotera') {
      return 'iotera'
    } else if (category[i] === 'emma') {
      return 'emma'
    } else if (category[i] === 'imou_camera') {
      return 'imou_camera'
    }
  }
}

export function saveToDeviceList(props, type) {
  if (type === 'DUMMY' || type === 'MQTT') {
    props.history.push('..' + S + '_device_list_')
  }
  else return //nope (for other situation)
}

export function goToURLActivation(props, selectedCategory) {
  if (selectedCategory === 'lora') {
    props.history.push('.' + S + 'activation' + S + 'lora');
  }
  else if (selectedCategory === 'zlan') {
    props.history.push('.' + S + 'activation' + S + 'zlan');
  }
  else if (selectedCategory === 'ui') {
    props.history.push('.' + S + 'activation' + S + 'usr-iot');
  }
  else if (selectedCategory === 'bivocom') {
    props.history.push('.' + S + 'activation' + S + 'bivocom');
  }
  else if (selectedCategory === 'friendcom') {
    props.history.push('.' + S + 'activation' + S + 'friendcom');
  }
  else if (selectedCategory === 'iotera') {
    props.history.push('.' + S + 'activation' + S + 'iotera');
  }
  else if (selectedCategory === 'emma') {
    props.history.push('.' + S + 'activation' + S + 'emma');
  }
  else if (selectedCategory === 'imou_camera') {
    props.history.push('.' + S + 'activation' + S + 'imou_camera');
  }
  else {
    props.history.push('.' + S + 'activation');
  }
}

export function callWSingleRequestCall(props, id, body) {
  props.wSingleRequestCall({
    id: id,
    body: body
  })
}

export function addDeviceConfig(dataToSubmit, config) {
  let _dataToSubmit = { ...dataToSubmit }
  _dataToSubmit['sensors'] = config
  return _dataToSubmit
}

export function storeDeviceConfig(dataToSubmit) {
  let action = setDeviceConfigPayload(dataToSubmit)
  store.dispatch(action)
}